import img1 from '@pages/Install/components/Comments/assets/1.png'
import img2 from '@pages/Install/components/Comments/assets/2.png'
import img3 from '@pages/Install/components/Comments/assets/3.png'
import img4 from '@pages/Install/components/Comments/assets/4.png'
import img5 from '@pages/Install/components/Comments/assets/5.png'
import img6 from '@pages/Install/components/Comments/assets/6.png'
import img7 from '@pages/Install/components/Comments/assets/7.png'
import img8 from '@pages/Install/components/Comments/assets/8.png'
import img9 from '@pages/Install/components/Comments/assets/9.png'
import img10 from '@pages/Install/components/Comments/assets/10.png'
// import img11 from '@pages/Install/components/Comments/assets/11.png'
// import img12 from '@pages/Install/components/Comments/assets/12.png'
// import img13 from '@pages/Install/components/Comments/assets/13.png'
// import img14 from '@pages/Install/components/Comments/assets/14.png'
// import img15 from '@pages/Install/components/Comments/assets/15.png'
// import img16 from '@pages/Install/components/Comments/assets/16.png'
// import img17 from '@pages/Install/components/Comments/assets/17.png'
// import img18 from '@pages/Install/components/Comments/assets/18.png'
// import img19 from '@pages/Install/components/Comments/assets/19.png'
// import img20 from '@pages/Install/components/Comments/assets/20.png'
// import img21 from '@pages/Install/components/Comments/assets/21.png'
// import img22 from '@pages/Install/components/Comments/assets/22.png'
// import img23 from '@pages/Install/components/Comments/assets/23.png'

export const listComments = [
  {
    icon: img1,
    name: 'धर्मात्मा',
    countStarts: 5,
    date: 'April 8, 2024',
    comment: 'एविएटर एक अच्छा ऐप है जहां आप दांव और कैसीनो पर अच्छा पैसा कमा सकते हैं',
    peopleFound: 2,
  },
  {
    icon: img2,
    name: 'সलियो मेस्सी',
    countStarts: 16,
    date: 'April 1, 2024',
    comment: 'एविएटर एक बेहतरीन ऐप है जिसकी अनुशंसा मैं सभी को करता हूँ',
    peopleFound: 16,
  },
  {
    icon: img3,
    name: 'बॉन्डुएल\n',
    countStarts: 5,
    date: 'March 29, 2024',
    comment:
      'Aviator is a great and easy earning company. I downloaded the application and I do not regret it. I play with pleasure and withdraw the money I earn to a bank account or even e-wallet. I advise you to try playing, you will not regret it. I have already recommended it to all my friends and acquaintances\n',
    peopleFound: 54,
  },
  {
    icon: img4,
    name: 'ट्रेज़र\n',
    countStarts: 4,
    date: 'March 25, 2024',
    comment:
      'मैंने उत्कृष्ट एविएटर ऑनलाइन कैसीनो ऐप डाउनलोड किया, अच्छी जीत, उच्च संभावनाएँ और त्वरित भुगतान। बहुत अच्छा!!!\n',
    peopleFound: 1,
  },
  {
    icon: img5,
    name: 'चेरी पाई\n',
    countStarts: 5,
    date: 'March 20, 2024',
    comment:
      'एविएटर ऐप शीर्ष स्तर का है, मुझे एविएटर वास्तव में पसंद आया, यह वास्तव में बहुत अच्छा है, एविएटर में दरें यथासंभव अच्छी हैं, मैं हर किसी को एविएटर की सिफारिश करता हूं क्योंकि यह वास्तव में बहुत अच्छा है, मुझे एविएटर वास्तव में पसंद आया, वास्तव में एविएटर डाउनलोड करें, आपको यहां पछतावा नहीं होगा, आप कमाते हैं बहुत जल्दी, आपको इसका पछतावा नहीं होगा, आपके द्वारा कमाया गया पैसा अनावश्यक नहीं होगा, मैं सभी को एविएटर डाउनलोड करने की सलाह देता हूं',
    peopleFound: 22,
  },
  {
    icon: img6,
    name: 'मैथ्यू\n',
    countStarts: 5,
    date: 'March 9, 2024',
    comment:
      'अद्भुत खेल, मुझे वास्तव में यह पसंद आया, ढेर सारे फायदे, ढेर सारी सकारात्मक भावनाएं, ढेर सारे अतिरिक्त कार्य, अगर कुछ कमियां हैं, जिन पर काम करने की जरूरत है, लेकिन कुल मिलाकर मैं एप्लिकेशन और इस तथ्य से संतुष्ट हूं कि एविएटर ने बहुत अच्छा काम किया है एविएटर यह मेरे लिए पूरी तरह से उपयुक्त था, मुझे वास्तव में हर कोई पसंद आया और अच्छा मूड अच्छा था\n',
    peopleFound: 6,
  },
  {
    icon: img7,
    name: 'अप्रमाणित सत्य\n',
    countStarts: 5,
    date: 'March 1, 2024',
    comment: 'Aviator is a good application where you can make good money on bets and casinos.\n',
    peopleFound: 0,
  },
  {
    icon: img8,
    name: 'ब्लैक.बुगाटी\n',
    countStarts: 5,
    date: 'February 26, 2024',
    comment:
      'গमैंने कई कैसिनो और सट्टेबाजों में खेला। एविएटर हर मामले में अव्वल है. लेकिन मुख्य मानदंड एक मिनट के भीतर धन की निकासी है। मैं इसकी अनुशंसा करता हूं। शानदार लाइन, शानदार संभावनाएं, सुंदर डिजाइन, अद्भुत स्लॉट, सुविधाजनक एप्लिकेशन मेनू। मैं तकनीकी सहायता पर विशेष ध्यान देना चाहूंगा! निकासी राशि के आधार पर 5-20 मिनट के भीतर बिना कमीशन के भुगतान, धनराशि जमा करने के लिए बहुत सारे उपकरण\n',
    peopleFound: 34,
  },
  {
    icon: img9,
    name: 'अज्ञात\n',
    countStarts: 5,
    date: 'February 24, 2024',
    comment:
      "Very good application, I did not even think that you can win money on Aviator, I advise everyone to install the Aviator application, place bets and win money, because as they say, there is never too much money Have a chance to win with pleasure, and it's great, good luck to everyone who joins Aviator, good luck placing bets in this wonderful application.\n",
    peopleFound: 9,
  },
  {
    icon: img10,
    name: 'फर्डिनेंड\n',
    countStarts: 5,
    date: 'February 22, 2024',
    comment:
      'एविएटर, सभी के लिए बढ़िया एप्लिकेशन और इसमें कोई समस्या नहीं है और बाकी सब ठीक है। सरल, सहज अनुप्रयोग. यहां तक ​​कि एक नौसिखिया भी इसे समझ सकता है, इसलिए आप डाउनलोड कर सकते हैं, इंस्टॉल कर सकते हैं और खेलना शुरू कर सकते हैं। इस दिशा में आप इस गेम को खेलकर न केवल आराम कर सकते हैं, बल्कि पैसे भी कमा सकते हैं। डाउनलोड करो और इंस्टॉल करो।\n',
    peopleFound: 1,
  },
  // {
  //   icon: img11,
  //   name: 'তাসনিম হাকিম',
  //   countStarts: 4,
  //   date: 'February 18, 2024',
  //   comment:
  //     'প্রথম দেখাতেই ভালোবাসা যাকে বলে! আমি এক্টিভলি খেলি এবং এটা প্রতি মিনিটে মিনিটে আমার মাঝে আনন্দ নিয়ে আসে।',
  //   peopleFound: 22,
  // },
  // {
  //   icon: img12,
  //   name: 'আরিফ আহমেদ',
  //   countStarts: 4,
  //   date: 'February 1, 2024',
  //   comment:
  //     'আমি আমার একাউন্টে টাকা ভরেছি, খেলেছি, এবং দেখুন, আমি জিতেছি! আমি নিজে নিজে চেষ্টা করার আগে এইসব গল্পগুলিতে খুব কমই বিশ্বাস করতাম। আর এখন আমি এটা প্রত্যেককে সাজেস্ট করলাম!',
  //   peopleFound: 43,
  // },
  // {
  //   icon: img13,
  //   name: 'ইয়াসমিন আবদুল্লাহ',
  //   countStarts: 5,
  //   date: 'January 30, 2024',
  //   comment:
  //     'আমি আনন্দে আত্মহারা হয়ে গিয়েছিলাম এটা দেখে যে কীভাবে আমার বন্ধু ধারাবাহিকভাবে বড় অঙ্কের অর্থ জিতেছে। সমস্ত কিছু সাথে সাথেই কার্যকর হয়নি, তবে জ্যাকপট একেবারে সমস্ত বিনিয়োগ আর ইনভেস্টমেন্ট আমাদের পরিশোধ করে দিয়েছে। অবিশ্বাস্য এ বিজয় এবং আনন্দের জন্য ধন্যবাদ!',
  //   peopleFound: 14,
  // },
  // {
  //   icon: img14,
  //   name: 'Sumit Saha',
  //   countStarts: 4,
  //   date: 'January 28, 2024',
  //   comment:
  //     'Hello friends, I want to share with you my impression about Crazy time application!!! Although I am not a gambling person, I was impressed by this application, you can bet safely and win, and withdrawing funds is very convenient. Bright and clear graphics! In general, good luck to all beginners and enthusiastic players',
  //   peopleFound: 67,
  // },
  // {
  //   icon: img15,
  //   name: 'Amitabh Biswas',
  //   countStarts: 5,
  //   date: 'January 20, 2024',
  //   comment:
  //     'Crazy time is a great and easy earning company. I downloaded the application and I do not regret it. I play with pleasure and withdraw the money I earn to a bank account or even e-wallet. I advise you to try playing, you will not regret it. I have already recommended it to all my friends and acquaintances',
  //   peopleFound: 0,
  // },
  // {
  //   icon: img16,
  //   name: 'Sunil Raychoudhury',
  //   countStarts: 5,
  //   date: 'January 19, 2024',
  //   comment:
  //     'A very good Crazy time app. I like it very much. I recommend everyone to download this wonderful, amazing application, you can do a lot and it works very well. I highly recommend downloading this application, it is very well done. Thanks to the developers for such a wonderful application',
  //   peopleFound: 12,
  // },
  // {
  //   icon: img17,
  //   name: 'Aniruddh Kar',
  //   countStarts: 5,
  //   date: 'January 28, 2024',
  //   comment:
  //     "Crazy time is the top best app for betting, it is absolutely amazing and starts from 20 to 12,000. Simply and easily. I used to play such bets and always lose, but in Aviator everything is fair, I never lose money and withdraw money with any payment method. Apart from this, there are many other wallets in which you can transfer money. If you don't believe me, check it out yourself!",
  //   peopleFound: 23,
  // },
  // {
  //   icon: img18,
  //   name: 'Srijit Rahman',
  //   countStarts: 5,
  //   date: 'January 12, 2024',
  //   comment:
  //     'Crazy time, great application for everyone and it has no problems and everything else is fine. Simple, intuitive application. Even a newbie can understand it, so you can download, install and start playing. In this direction, you can not only relax but also earn money by playing this game. Download and install.',
  //   peopleFound: 19,
  // },
  // {
  //   icon: img19,
  //   name: 'Maushum Choudhury',
  //   countStarts: 5,
  //   date: 'January 11, 2024',
  //   comment:
  //     'Crazy time is an excellent application, clear interface, excellent graphics, no lag. Even a novice can figure it out. But the main advantage is that you can also earn extra money here! This is absolutely great! I have been using this application for a long time, it has never let me down, the output to the card is very convenient! In general, I recommend it to everyone.',
  //   peopleFound: 43,
  // },
  // {
  //   icon: img20,
  //   name: 'Ranjit Chakravarty',
  //   countStarts: 5,
  //   date: 'January 3, 2024',
  //   comment:
  //     "A very excellent company Crazy time, big wins, fast payouts and high possibilities, many sports games, very convenient and easy to use, even a newbie can figure it out in a few clicks and you are already earning money. So far, I've only heard mediocre comments about this app. I recommend everyone to try",
  //   peopleFound: 26,
  // },
  // {
  //   icon: img21,
  //   name: 'Ajit Das',
  //   countStarts: 5,
  //   date: 'January 3, 2024',
  //   comment:
  //     "Very good application, I did not even think that you can win money on Crazy time, I advise everyone to install the Crazy time application, place bets and win money, because as they say, there is never too much money Have a chance to win with pleasure, and it's great, good luck to everyone who joins Aviator, good luck placing bets in this wonderful application.",
  //   peopleFound: 23,
  // },
  // {
  //   icon: img22,
  //   name: 'Manish Mukhopadhyay',
  //   countStarts: 5,
  //   date: 'January 3, 2024',
  //   comment:
  //     'Very nice application. I never thought that I could get a lot of money. I recommend everyone to download this application',
  //   peopleFound: 19,
  // },
  // {
  //   icon: img23,
  //   name: 'Vikram Pande',
  //   countStarts: 5,
  //   date: 'December 27, 2023',
  //   comment:
  //     "Crazy time app is really good. I didn't think it was that easy. You install it and it works immediately. Overall very good. So I thought it was another scam. But I was sure that was not the case.",
  //   peopleFound: 67,
  // },
]
